<template>
  <div class="landing landing__with_sp">
    <Breadcrumbs />

    <header>
      <div class="d-flex flex-column align-center justify-center">
        <h1 v-if="h1" class="text-black ma-2 text-center" style="">{{ h1 }}<span @click="open_select_city_dialog" class="ml-2" style="color: rgb(33, 150, 243); cursor: pointer;">{{ city_name }}</span></h1>
        <p v-if="h1_text" class="headline text-black"> {{ h1_text }} </p>
      </div>
    </header>

    <SavedOffers />

    <Section
      v-for="section in sections"
      :section="section"
      :key="section.title"
    />

    <LastCalcs />

    <LandingText :text="text1" />

    <LandingReviews />

    <Offices />

    <LandingText :text="text2" />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import vuetify from '../../plugins/vuetify';
import { defineAsyncComponent } from 'vue';

export default {
  components: {
    LandingReviews: defineAsyncComponent(() => import("../../components/landing/LandingReviews.vue")),
    LandingText: defineAsyncComponent(() => import("../../components/landing/LandingText.vue")),
    Offices: defineAsyncComponent(() => import("../../components/landing/Offices.vue")),
    LastCalcs: defineAsyncComponent(() => import("../../components/landing/LastCalcs.vue")),
    SavedOffers: defineAsyncComponent(() => import("../../components/landing/SavedOffers.vue")),
    Breadcrumbs: defineAsyncComponent(() => import("../../components/landing/Breadcrumbs.vue")),
    Section: defineAsyncComponent(() => import("../../components/landing/Section.vue")),
  },
	data() {
		return {
		};
	},
	computed: {
		...mapState({
      sections: (state) => state.LandingM.page_params.sections,
      isMobile: (state) => state.isMobile,
      text1: (state) => state.LandingM.page_params.text1,
      text2: (state) => state.LandingM.page_params.text2,
      h1: (state) => state.LandingM.page_params.h1,
      h1_text: (state) => state.LandingM.page_params.h1_text,
      city_name: (state) => state.LandingM.city_name,
		}),
		breadcrumbs() {
      let breads = [
        {
          text: 'Ландинг',
          disabled: false,
          href: '/',
          position: '1',
        },
      ];
      let selected_city_name = this.selected_city_name;
      if (selected_city_name && selected_city_name !== 'России') {
        breads.push({
          text: selected_city_name,
          disabled: false,
          href: '/',
          position: 2,
        })
      }
      if (this.page_name) {
        breads.push({
          text: this.page_name,
          disabled: true,
          href: '/',
          position: 3,
        })
      }
      return breads
		},
	},
  methods: {
    open_select_city_dialog() {
			this.$store.dispatch("select_one_city");
    }
	},
  beforeRouteEnter(to, from, next) {
    let city_slug = to.params.city_slug;
    let sp_slug = to.params.sp_slug;
    if (!sp_slug) {
      next(false)
      return
    }
    if (!city_slug) {
      city_slug = 'russia';
      next({ name: 'WithStatic', params: {city_slug, sp_slug }});
      return
    }
    next(vm => {
      vm.$store.dispatch("getPageParams", to.path);
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("getPageParams", to.path);
		vuetify.framework.goTo(0);
    next()
  },
}
</script>
